import { ALLOWED_REDIRECTS } from './constants';

export function safeNextPath(raw) {
  if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//') || (raw.includes('\\') || [...raw].some(char => char.charCodeAt(0) <= 32))) return '/listings';
  try {
    const url = new URL(raw, 'https://carva.local');
    if (url.origin !== 'https://carva.local' || !ALLOWED_REDIRECTS.includes(url.pathname)) return '/listings';
    return url.pathname + url.search + url.hash;
  } catch {
    return '/listings';
  }
}

export function nextFromSearch(search) {
  return safeNextPath(new URLSearchParams(search).get('next'));
}

export function authLink(route, next) {
  const destination = safeNextPath(next);
  return destination === '/listings' ? route : `${route}?${new URLSearchParams({ next: destination })}`;
}
